import "whatwg-fetch";

// Private variables
let active_class = "select-mode-active";

export default class CollectionBar {
    constructor() {
        this.dom = { el: document.querySelector(".collection-bar") };

        this.bus = document.createElement("div");

        this.assign();
        this.events();
    }

    assign() {
        this.dom.add_collection = this.dom.el.querySelector(
            "#add-to-collection"
        );
        this.dom.add_cart = this.dom.el.querySelector("#add-to-cart");
        this.dom.add_cart_modal = document.querySelector("#add-to-cart-modal");
        this.dom.add_collection_modal = document.querySelector(
            "#add-to-collection-modal"
        );
        this.dom.close = this.dom.el.querySelector(".collection-bar-button");
        this.dom.finished = this.dom.el.querySelector("#closeButton");
        this.dom.icon_check = '<span class="fas fa-check">&nbsp;</span>';
    }

    events() {
        this.bus.addEventListener("open", this.open);
        this.bus.addEventListener("close", this.close);
        this.bus.addEventListener("discard", this.discard);

        this.dom.close.addEventListener("click", () => {
            this.discard();
        });

        this.dom.add_collection.addEventListener("click", e => {
            if (e.target.classList.contains("noswatches")) {
            } else if (!this.dom.add_collection.classList.contains("success")) {
                this.add_collection();
            }
        });

        this.dom.add_cart.addEventListener("click", e => {
            if (e.target.classList.contains("noswatches")) {
            } else if (
                !this.dom.add_cart.classList.contains("success") &&
                !this.dom.add_cart.classList.contains("success")
            ) {
                this.add_cart();
            }
        });
    }

    // Need a way of doing this in a cleaner way;
    unselect() {
        let s = [...document.querySelectorAll(".selected")];
        if (s.length > 0) {
            s.map(e => {
                e.classList.remove("selected");
            });
        }
    }

    unselect_tabs() {
        this.unselect();

        let s = [...document.querySelectorAll(".tab.active")];
        if (s.length > 0) {
            s.map(e => {
                e.classList.remove("active");
            });
        }

        let l = [...document.querySelectorAll(".letter-tag.active")];
        if (l.length > 0) {
            l.map(t => {
                t.classList.remove("active");
            });
        }
    }

    discard() {
        if (
            this.dom.add_cart.classList.contains("success") ||
            this.dom.add_collection.classList.contains("success")
        ) {
            this.close();
            this.unselect_tabs();
            document.body.classList.remove("small-modal");

            if (this.dom.finished) {
                this.dom.finished.innerHTML = `Discard selection`;
            }

            if (this.dom.close) {
                this.dom.close.innerHTML = `Done`;
            }
        } else {
            // Should trigger via event
            // document.body.classList.add("small-modal");
        }
    }

    close() {
        document.body.classList.remove(active_class);

        this.dom.add_cart.classList.remove("success");
        this.dom.add_collection.classList.remove("success");
    }

    toggle_buttons() {
        this.dom.add_cart.classList.remove("success");
        this.dom.add_collection.classList.remove("success");
    }

    open() {
        document.body.classList.add(active_class);
        
        if (this.dom.close) {
            this.dom.close.innerHTML = `Done`;
        }
    }

    add_cart() {
        window.collection.trigger("request");

        if (window.stagedProducts.length === 0) {
            window.collection.trigger("success");
        } else {
            window.stagedProducts.forEach(product => {
                const productObject = JSON.parse(product);

                delete productObject.id;

                fetch("/umbraco/surface/cart/savecartitem", {
                    method: "POST",
                    body: JSON.stringify(productObject),
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => {
                        window.collection.trigger("success");
                        this.dom.add_cart.classList.remove("loading");
                        this.dom.add_cart.classList.add("success");
                        this.dom.add_cart_modal.classList.remove("loading");
                        this.dom.add_cart_modal.classList.add("success");
                        this.dom.add_cart_modal.innerHTML = `${
                            this.dom.icon_check
                        } Added to sample cart`;
                        this.dom.close.innerHTML = `Done`;

                        if (this.dom.finished) {
                            this.dom.finished = `Done`;
                        }

                        window.stagedProducts.clear();

                        return res.json();
                    })
                    .then(res => {
                        const cartCount = [
                            ...document.querySelectorAll(".js-cart-count")
                        ];
                        cartCount.map(cc => {
                            cc.innerHTML = res.TotalCartCount;
                        });
                    });
            });
        }
    }

    add_collection() {
        window.stagedProducts.forEach(product => {
            const o = JSON.parse(product);

            if (o.id.includes("-")) {
                window.collection.add("products", o.id.split("-")[1]);
            } else {
                window.collection.add("products", o.id);
            }
        });

        if (this.dom.add_cart.classList.contains("success")) {
            window.stagedProducts.clear();
        }

        return window.collection.save().then(res => {
            this.dom.close.innerHTML = `Done`;

            if (this.dom.finished) {
                this.dom.finished.innerHTML = `Done`;
            }
            this.dom.add_collection.classList.remove("loading");
            this.dom.add_collection.classList.add("success");
            this.dom.add_collection_modal.classList.remove("loading");
            this.dom.add_collection_modal.classList.add("success");
            this.dom.add_collection_modal.innerHTML = `${
                this.dom.icon_check
            } Added to collection`;

            document.cookie =
                "collection=" +
                res +
                "; expires=Tue, 1 Jan 2030 12:00:00 UTC; path=/";

            return res;
        });
    }
}
